module.exports = __webpack_public_path__ + "static/media/frankvisser.3fb868a5.webp";


//////////////////
// WEBPACK FOOTER
// ./src/images/letterfunnel/frankvisser.webp
// module id = 468
// module chunks = 0